exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.row-fix[data-v-6d3d3098] {\r\n  position: fixed;\r\n  z-index: 99;\r\n  bottom: 1.5em;\r\n  right: 2.5em;\n}\n.buttonFixed[data-v-6d3d3098] {\r\n  margin: 6px;\n}\r\n\r\n\r\n", ""]);

// exports
